(() => {
  const qs = (selector, scope = document) => scope.querySelector(selector);
  const qsa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

  const drawer = qs('[data-cart-drawer]');
  const openDrawer = () => {
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mh-lock');
    qs('[data-cart-close]', drawer)?.focus();
  };
  const closeDrawer = () => {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mh-lock');
  };

  qsa('[data-cart-open]').forEach((button) => button.addEventListener('click', (event) => {
    event.preventDefault();
    openDrawer();
  }));
  qsa('[data-cart-close]').forEach((button) => button.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawer(); });

  const menu = qs('[data-mobile-menu]');
  qs('[data-menu-toggle]')?.addEventListener('click', (event) => {
    const open = menu?.classList.toggle('is-open');
    event.currentTarget.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  qsa('[data-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    if (!drawer || !window.fetch) return;
    event.preventDefault();
    const button = qs('[type="submit"]', form);
    const original = button?.textContent;
    if (button) { button.disabled = true; button.textContent = 'Adding…'; }
    try {
      const response = await fetch(window.Shopify?.routes?.root ? `${window.Shopify.routes.root}cart/add.js` : '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add this meal.');
      window.location.hash = 'cart-open';
      openDrawer();
      setTimeout(() => window.location.reload(), 350);
    } catch (error) {
      const message = qs('[data-product-error]', form);
      if (message) message.textContent = error.message;
    } finally {
      if (button) { button.disabled = false; button.textContent = original; }
    }
  }));

  // Purchase mode: a disabled <select> is not submitted, so choosing "one-time"
  // omits selling_plan entirely and Shopify treats it as a single purchase.
  qsa('[data-purchase-options]').forEach((group) => {
    const frequency = qs('[data-selling-plan]', group);
    const wrap = qs('[data-frequency-wrap]', group);
    if (!frequency) return;
    const sync = () => {
      const mode = qs('[data-purchase-mode]:checked', group)?.value;
      const subscribing = mode === 'subscribe';
      frequency.disabled = !subscribing;
      if (wrap) wrap.hidden = !subscribing;
    };
    qsa('[data-purchase-mode]', group).forEach((radio) => radio.addEventListener('change', sync));
    sync();
  });

})();
